import { Swiper } from 'swiper';

class BlockRecentsDocumentsList {
  constructor() {
    this._init();
  }

  _init() {
    new Swiper('.recents-documents-list__swiper', {
      direction: 'horizontal',
      slidesPerView: 1.5,
      spaceBetween: 2,
      speed: 3000,
      autoplay: {
        delay: 10,
        disableOnInteraction: false
      },
      breakpoints: {
        640: {
          slidesPerView: 3,
          spaceBetween: 8
        },
        1025: {
          slidesPerView: 4,
          spaceBetween: 8
        }
      }
    });
  }
}

export const blockRecentsDocumentsList = new BlockRecentsDocumentsList();
